import { createApp } from 'vue'
import { createPinia } from 'pinia'
import ElementPlus from 'element-plus'
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
import 'element-plus/dist/index.css'
import '@/styles/index.css'
import App from './App.vue'
import router from './router'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import { generateTestData } from '@/utils/mock'
import { useSiteSettings } from '@/composables/useSiteSettings'

// 禁用Element Plus的调试警告输出
if (typeof window !== 'undefined') {
  window.__DEV__ = false
}

const app = createApp(App)

// 注册Element Plus图标
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

// 配置Element Plus
app.use(ElementPlus, {
  locale: zhCn,
  size: 'default',
  zIndex: 3000,
  // 禁用调试模式
  debug: false,
  // 自定义主题色
  theme: {
    colors: {
      primary: 'rgb(96, 91, 255)',
    }
  }
})

app.use(createPinia())
app.use(router)

// 错误处理
app.config.errorHandler = (err, vm, info) => {
  console.error('Vue Error:', err.message || '未知错误')
  console.error('Error Info:', info)
  // 避免输出完整的错误对象，可能包含敏感信息
}

// 初始化测试数据
const initTestData = () => {
  // 检查是否已有数据
  const existingAuthList = localStorage.getItem('auth_list')
  const existingRecycleList = localStorage.getItem('auth_recycle')
  
  if (!existingAuthList || !existingRecycleList) {
    console.log('正在生成测试数据...')
    generateTestData()
    console.log('测试数据生成完成')
  }
}

// 在应用启动时初始化测试数据
initTestData()

// 挂载应用
app.mount('#app')

// 应用挂载后初始化站点设置
const initSiteSettings = async () => {
  const { fetchSiteSettings, updatePageMeta } = useSiteSettings()
  try {
    // 首先使用默认设置更新页面
    updatePageMeta()
    // 然后从API获取最新设置
    await fetchSiteSettings()
  } catch (error) {
    console.warn('站点设置初始化失败，使用默认设置:', error.message)
    updatePageMeta()
  }
}

initSiteSettings()